/**
 * registration editのzip/prefectureを動的に扱うformです
 */
import $ from 'jquery';
import { AddressForm, InputValue } from '../components/address_form';

const inputValue: InputValue = {
  inputPrefecture: 'user_company_attributes_prefecture',
};

{
  AddressForm;
}

const setMailingFieldsState = (fields: HTMLElement, destroyField: HTMLInputElement | null, enabled: boolean): void => {
  fields.style.display = enabled ? '' : 'none';
  fields.querySelectorAll('input, select, textarea').forEach((el) => {
    if (el instanceof HTMLInputElement || el instanceof HTMLSelectElement || el instanceof HTMLTextAreaElement) {
      el.disabled = !enabled;
    }
  });
  if (destroyField) {
    destroyField.value = enabled ? '0' : '1';
  }
};

const syncCompanyName = (): void => {
  const companyNameInput = document.getElementById('user_company_attributes_name');
  const postalCompanyNameInput = document.getElementById(
    'user_company_attributes_invoice_postal_address_attributes_company_name'
  );

  if (!(companyNameInput instanceof HTMLInputElement) || !(postalCompanyNameInput instanceof HTMLInputElement)) return;

  if (!postalCompanyNameInput.value) {
    postalCompanyNameInput.value = companyNameInput.value;
  }

  companyNameInput.addEventListener('input', () => {
    postalCompanyNameInput.value = companyNameInput.value;
  });
};

const toggleMailingFields = (): void => {
  const checkbox = document.getElementById('invoice_mailing_required');
  const fields = document.getElementById('invoice-mailing-address-fields');
  const destroyField = document.getElementById('invoice_postal_address_destroy');
  if (!(checkbox instanceof HTMLInputElement) || !fields) return;
  const destroy = destroyField instanceof HTMLInputElement ? destroyField : null;

  if (checkbox.checked) syncCompanyName();
  setMailingFieldsState(fields, destroy, checkbox.checked);
  checkbox.addEventListener('change', () => {
    if (checkbox.checked) syncCompanyName();
    setMailingFieldsState(fields, destroy, checkbox.checked);
  });
};

// NOTE: 画面遷移した時用
document.addEventListener('turbolinks:load', () => {
  AddressForm(inputValue);
  toggleMailingFields();
});

// NOTE: リフレッシュした時用
$(document).ready(() => {
  AddressForm(inputValue);
  toggleMailingFields();
});
